/* eslint-disable */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getLastElement = function getLastElement(name) {
  var group = document.getElementsByName(name);
  return group[group.length - 1];
};

exports.default = getLastElement;